import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { motion } from "framer-motion";
import { FAQS } from "../../lib/site-data";
import SectionLabel from "./SectionLabel";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-pad bg-[#0A0A0A] text-white relative overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-orange-600/15 blur-[120px] pointer-events-none"
      />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-4"
          >
            <SectionLabel dark>Frequently Asked Questions</SectionLabel>
            <h2
              data-testid="faq-headline"
              className="font-display mt-8 text-xl md:text-2xl font-bold tracking-tightest leading-[1.05]"
            >
              Everything you need to know.
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
            className="lg:col-span-8"
          >
            <Accordion
              type="single"
              collapsible
              className="w-full"
              data-testid="faq-accordion"
            >
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={item.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-white/10 last:border-b-0"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-display text-lg md:text-xl font-semibold tracking-tight hover:no-underline hover:text-orange-500 py-5"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-[15px] text-white/65 leading-relaxed pr-2 pb-5"
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
            <p className="mt-6 text-base text-white/60 leading-relaxed" data-testid="faq-still-curious">
              Still curious? Reach out via the contact section below.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
